var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRowRightActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u523A\\u732C\\u5B98\\u7F51-\\u65B9\\u6848\\u8349\\u7A3F1",
    transform: "translate(-234.000000, -880.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(226.000000, 872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9460938,11.409375 L7.38046875,3.15703125 C7.25625,3.0609375 7.078125,3.14765625 7.078125,3.3046875 L7.078125,5.11640625 C7.078125,5.23125 7.13203125,5.34140625 7.22109375,5.41171875 L15.6585937,12 L7.22109375,18.5882813 C7.1296875,18.6585938 7.078125,18.76875 7.078125,18.8835938 L7.078125,20.6953125 C7.078125,20.8523438 7.25859375,20.9390625 7.38046875,20.8429688 L17.9460938,12.590625 C18.3304688,12.290625 18.3304688,11.709375 17.9460938,11.409375 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowRightActive);
export default __webpack_public_path__ + "static/media/rowRightActive.604658480246f17068ced858337c7553.svg";
export { ForwardRef as ReactComponent };